import { EmployeePositions } from "~/schemas/generated/graphql";

export const encodeDealers = (dealers: EmployeePositions[]) => {
  return dealers.map((dealer) => {
    return encodeURI(`${dealer.DealerId}, ${dealer.Dealer.DealerName}`);
  });
};
